import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { BundleItemItemApi } from "../../../../../../../../../../../../services/Api/Organization/types";

interface Props {
	items: BundleItemItemApi[];
}

const BundleFormItemsSummaryRow = ({ items }: Props) => {
	const organization = useSelector(selectOrganization);
	const { t } = useTranslation();

	const totalMacCost = items.reduce(
		(acc, cur) => acc + (cur.quantity || 0) * (cur?.unit_fifo_cost_net_money?.amount || 0),
		0
	);

	return (
		<tr className="summary">
			<td className="action" />
			<td />
			<td>{t("common.word.estimated_cost")}</td>
			<td className="text-end">
				{FormatMoney({ amount: totalMacCost, currency: organization?.currency || "PLN" })}
			</td>
			<td className="action" />
		</tr>
	);
};

export default BundleFormItemsSummaryRow;
